import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=b8f118ec&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=ts"
export * from "./ComponentHeader.vue?vue&type=script&lang=ts"
import style0 from "./ComponentHeader.vue?vue&type=style&index=0&id=b8f118ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f118ec",
  null
  
)

export default component.exports